(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.WHCardExtras) return;
    window.WHCardExtras = true;

    var EVERY_NTH = 4;
    var CARD = '.product-card-wrapper';
    var GAP_BELOW_BADGES = 8;

    function buildIframe(slot) {
      if (slot.dataset.whLoaded) return;
      slot.dataset.whLoaded = '1';
      var src = slot.getAttribute('data-gumlet-src');
      if (!src) return;
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      var f = document.createElement('iframe');
      f.className = 'card-gumlet-video';
      f.src = src + sep + 'autoplay=true&loop=true&muted=true&disable_player_controls=true&preload=true';
      f.title = slot.getAttribute('data-title') || 'Product video';
      f.setAttribute('referrerpolicy', 'origin');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      f.setAttribute('tabindex', '-1');
      f.setAttribute('aria-hidden', 'true');
      slot.appendChild(f);
    }

    var videoIO = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { buildIframe(en.target); videoIO.unobserve(en.target); }
          });
        }, { rootMargin: '300px' })
      : null;

    function itemOf(card) {
      return card.closest('li, .grid__item, .slider__slide, .swiper-slide') || card.parentElement;
    }

    function scanVideos() {
      var lists = new Set();
      document.querySelectorAll(CARD).forEach(function (c) {
        var it = itemOf(c);
        if (it && it.parentElement) lists.add(it.parentElement);
      });
      lists.forEach(function (list) {
        var items = Array.prototype.filter.call(list.children, function (ch) {
          return ch.matches(CARD) || ch.querySelector(CARD);
        });
        items.forEach(function (item, i) {
          if ((i + 1) % EVERY_NTH !== 0) return;
          var slot = item.querySelector('.card-gumlet-slot');
          if (!slot || slot.dataset.whActive) return;
          slot.dataset.whActive = '1';
          videoIO ? videoIO.observe(slot) : buildIframe(slot);
        });
      });
    }

    function positionGift(card) {
      var chip = card.querySelector('.wh-free-gift');
      if (!chip) return;
      var wrap = card.querySelector('.card__image-wrapper');
      var slot = card.querySelector('.wh-badges-slot');
      var top = 10;

      if (wrap) {
        var wr = wrap.getBoundingClientRect();
        if (wr.height === 0) return;
        if (slot) {
          var maxBottom = 0;
          slot.querySelectorAll('*').forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.width > 0 && r.height > 0) {
              maxBottom = Math.max(maxBottom, r.bottom - wr.top);
            }
          });
          if (maxBottom > 0) top = Math.round(maxBottom + GAP_BELOW_BADGES);
        }
      }

      chip.style.setProperty('--wh-gift-top', top + 'px');
      chip.setAttribute('data-wh-pos', '1');
    }

    var giftRO = 'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (en) {
            var card = en.target.closest(CARD);
            if (card) positionGift(card);
          });
        })
      : null;

    function scanGiftPositions() {
      document.querySelectorAll(CARD + '.has-free-gift:not([data-wh-ro])').forEach(function (card) {
        card.setAttribute('data-wh-ro', '1');
        var wrap = card.querySelector('.card__image-wrapper') || card;
        if (giftRO) giftRO.observe(wrap);
        positionGift(card);
      });
    }

    function repositionAll() {
      document.querySelectorAll(CARD + '.has-free-gift').forEach(positionGift);
    }

    window.addEventListener('resize', repositionAll);

    /* ================= FREE GIFT FALLBACK (all_products 20-handle limit) ================= */
    var giftCache = {};
    var fmt = (function () {
      try {
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
        var nf = new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: 0 });
        return function (cents) { return nf.format(cents / 100); };
      } catch (e) {
        return function (cents) { return '₹' + Math.round(cents / 100); };
      }
    })();

    function getGiftProduct(handle) {
      if (!giftCache[handle]) {
        giftCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return giftCache[handle];
    }

    function fillGift(el) {
      if (el.dataset.whFilled) return;
      el.dataset.whFilled = '1';
      var handle = el.getAttribute('data-gift-handle');
      var vid = Number(el.getAttribute('data-gift-variant'));

      getGiftProduct(handle).then(function (p) {
        var card = el.closest(CARD);
        if (!p || !p.variants) {
          if (card) card.classList.remove('has-free-gift');
          el.remove();
          return;
        }
        var v = p.variants.filter(function (x) { return x.id === vid; })[0] || p.variants[0];
        var src = (v.featured_image && v.featured_image.src) || p.featured_image;

        var thumb = el.querySelector('.wh-free-gift__thumb');
        if (src && thumb && !thumb.querySelector('img')) {
          var img = document.createElement('img');
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          img.alt = p.title;
          img.width = 80;
          img.height = 80;
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        var t = el.querySelector('.wh-free-gift__title');
        if (t) t.textContent = p.title;
        var w = el.querySelector('.wh-free-gift__worth');
        if (w && v.price > 0) w.textContent = 'Worth ' + fmt(v.price);

        el.classList.remove('wh-free-gift--pending');
        if (card) positionGift(card);
      });
    }

    var giftIO = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { fillGift(en.target); giftIO.unobserve(en.target); }
          });
        }, { rootMargin: '300px' })
      : null;

    function scanGifts() {
      document.querySelectorAll('.wh-free-gift--pending:not([data-wh-obs])').forEach(function (el) {
        el.setAttribute('data-wh-obs', '1');
        giftIO ? giftIO.observe(el) : fillGift(el);
      });
    }

    /* ================= INIT ================= */
    function scan() {
      scanVideos();
      scanGiftPositions();
      scanGifts();
    }

    var timer;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(scan, 150);
    });

    function init() {
      scan();
      mo.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('load', repositionAll);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(repositionAll);
    }

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init)
      : init();

    window.WHCardExtras = { scan: scan };
  })();
  } catch(e) { console.error(e); }
})();

})();
